import React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { GroupRole } from "../../lib/types";

interface MemberRoleSelectorProps {
  value: GroupRole;
  onChange: (role: GroupRole) => void;
  disabled?: boolean;
}

const MemberRoleSelector: React.FC<MemberRoleSelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  return (
    <FormControl size="small" disabled={disabled}>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value as GroupRole)}
      >
        <MenuItem value="owner">Owner</MenuItem>
        <MenuItem value="admin">Admin</MenuItem>
        <MenuItem value="editor">Editor</MenuItem>
        <MenuItem value="viewer">Viewer</MenuItem>
      </Select>
    </FormControl>
  );
};

export default MemberRoleSelector;
